import { getJson, queryString } from "../client";
import { ENVOY_BASE } from "./base";

export interface OverviewStatuses {
    matched: number;
    tailoring: number;
    ready: number;
    needs_you: number;
    applied: number;
    failed: number;
    skipped: number;
    closed: number;
}

export interface OverviewDay {
    /** `YYYY-MM-DD`, in `time_zone`. */
    date: string;
    matched: number;
    tailored: number;
    applied: number;
    skipped: number;
}

export interface EnvoyOverview {
    time_zone: string;
    statuses: OverviewStatuses;
    applied_last_7_days: number;
    /** Oldest first, today last. */
    days: OverviewDay[];
}

/** Where everything stands, with `days` days of activity in `timeZone`, today last. */
export function getEnvoyOverview(timeZone: string, days = 14): Promise<EnvoyOverview> {
    return getJson(`${ENVOY_BASE}/overview${queryString({ time_zone: timeZone, days })}`);
}
